import { render } from "./DynamicAppStoryElement.vue.js?vue&type=template&id=45420768!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppStoryElement.vue?vue&type=template&id=45420768"
import script from "./DynamicAppStoryElement.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppStoryElement.vue?vue&type=script&lang=js"
export * from "./DynamicAppStoryElement.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppStoryElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/dynamic-app-elements/display/DynamicAppStoryElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45420768"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45420768', __exports__)) {
    api.reload('45420768', __exports__)
  }
  
  module.hot.accept("./DynamicAppStoryElement.vue.js?vue&type=template&id=45420768!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppStoryElement.vue?vue&type=template&id=45420768", () => {
    api.rerender('45420768', render)
  })

}


export default __exports__